"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { useParams } from "next/navigation"
import { useMemo } from "react"
import { twMerge } from "tailwind-merge"
import { WeeklyLeafletContent } from "./components/WeeklyLeafletContent"
export interface WeeklyLeafletRenderProps {
  title: string
  className?: string
  id?: string
  viewAllUrl?: string
  isDisplayLink?: boolean
}

export const RenderConfig = {
  render: ({ title, className, id: componentId, viewAllUrl, isDisplayLink }: WeeklyLeafletRenderProps) => {
    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    const locale = (params?.locale as string) || storeLocale || "vi"
    const id = useMemo(() => componentId || `weekly-leaflet-${Math.random().toString(36).substr(2, 9)}`, [componentId])

    return (
      <div className={twMerge(className)} id={id}>
        <WeeklyLeafletContent
          title={title}
          locale={locale}
          className={className}
          viewAllUrl={viewAllUrl}
          isDisplayLink={isDisplayLink}
        />
      </div>
    )
  },
}
